import { CardContent, Typography, Stack, Box } from "@mui/material";
import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import utilities from "../../utility/utilities";
import { StyledCard } from "../../assets/styled-components/StyledCard";

function OpenClosedChart({ response }) {
  const recentMonths = utilities.getRecentSixMonths(); // Use utility to get recent 6 months
  const openClosedData = response?.woOpenVsClosedCounts || {};
  const opened = [
    (openClosedData?.sMonthSixOpenCount || 0) +
    (openClosedData?.unsMonthSixOpenCount || 0),
    (openClosedData?.sMonthFiveOpenCount || 0) +
    (openClosedData?.unsMonthFiveOpenCount || 0),
    (openClosedData?.sMonthFourOpenCount || 0) +
    (openClosedData?.unsMonthFourOpenCount || 0),
    (openClosedData?.sMonthThreeOpenCount || 0) +
    (openClosedData?.unsMonthThreeOpenCount || 0),
    (openClosedData?.sMonthTwoOpenCount || 0) +
    (openClosedData?.unsMonthTwoOpenCount || 0),
    (openClosedData?.sMonthOneOpenCount || 0) +
    (openClosedData?.unsMonthOneOpenCount || 0),
  ];

  const closed = [
    (openClosedData?.sMonthSixClosedCount || 0) +
    (openClosedData?.unsMonthSixClosedCount || 0),
    (openClosedData?.sMonthFiveClosedCount || 0) +
    (openClosedData?.unsMonthFiveClosedCount || 0),
    (openClosedData?.sMonthFourClosedCount || 0) +
    (openClosedData?.unsMonthFourClosedCount || 0),
    (openClosedData?.sMonthThreeClosedCount || 0) +
    (openClosedData?.unsMonthThreeClosedCount || 0),
    (openClosedData?.sMonthTwoClosedCount || 0) +
    (openClosedData?.unsMonthTwoClosedCount || 0),
    (openClosedData?.sMonthOneClosedCount || 0) +
    (openClosedData?.unsMonthOneClosedCount || 0),
  ];

  const totalOpened = opened.reduce((acc, value) => acc + value, 0);
  const totalClosed = closed.reduce((acc, value) => acc + value, 0);
  return (
    <StyledCard variant={"outlined"}>
      <CardContent>
        <Stack
          direction="row"
          spacing={1}
          flexWrap={"wrap"}
          useFlexGap
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color={"text.primary"}
          >
            W.O Open Vs Closed
          </Typography>
        </Stack>

        <Box width={"100%"}>
          <BarChart
            height={300}
            series={[
              { data: opened, label: (location) => location === 'tooltip' ? 'Opened' : `Opened(${totalOpened})`, id: "open", color: "#EF0107" },
              { data: closed, label: (location) => location === 'tooltip' ? 'Closed' : `Closed(${totalClosed})`, id: "close", color: "#4CAF50" },
            ]}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "center" },
                padding: 0,
                itemMarkWidth: 15,
                itemMarkHeight: 15,
                markGap: 5,
                itemGap: 16,
                labelStyle: {
                  fontSize: 12,
                  color: "text.primary",
                  fontWeight: 400,
                },
              },
            }}
            xAxis={[
              {
                data: recentMonths.map((month) => month.label),
                scaleType: "band",
                categoryGapRatio: 0.7,
                tickLabelStyle: {
                  // Adjust label font size
                  fontSize: 11,
                  overflowWrap: "break-word",
                  whiteSpace: "nowrap", // Prevents text from breaking
                },
              },
            ]}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
}

export default OpenClosedChart;
